import React from "react";
import {
  HeroContainer,
  HeroContent,
  HeroH1,
  HeroP,
  LinkGroup,
  LinkIcon,
} from "./HeroElements";
import { useTranslation } from "react-i18next";
import { animationVariants } from "../../constants/animationVariants";
import { BsLinkedin } from "react-icons/bs";
import { SiGmail } from "react-icons/si";
import { FaSquareGithub } from "react-icons/fa6";
import { IoPerson } from "react-icons/io5";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <HeroContainer>
      <HeroContent
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ staggerChildren: 0.2 }}
      >
        <HeroH1 variants={animationVariants.fadeLeft}>Jonatan Ochoa</HeroH1>
        <HeroH1 variants={animationVariants.fadeLeft}>
          {t("home.fullstack")}
        </HeroH1>
        <HeroP variants={animationVariants.fadeLeft}>{t("home.title")}</HeroP>
        <LinkGroup variants={animationVariants.fadeLeft}>
          <LinkIcon
            to="mailto:jonatan.c.ochoa@gmail.com"
            target="_blank"
            aria-label="Gmail"
          >
            <SiGmail color="red" />
          </LinkIcon>
          <LinkIcon
            to="https://linkedin.com/in/jona-ochoa"
            target="_blank"
            aria-label="Linkedin"
          >
            <BsLinkedin color="blue" />
          </LinkIcon>
          {/* <LinkIcon
            to="https://github.com/jona-ochoa"
            target="_blank"
            aria-label="Github"
          >
            <FaSquareGithub color="black" />
          </LinkIcon>
          <LinkIcon
            to="https://drive.google.com/file/d/1mIP0cA0fSiRYT4cEFPUsol5EQnhZ_LS6/view?usp=sharing"
            target="_blank"
            aria-label="Ver Curriculum"
          >
            <IoPerson color="black" />
          </LinkIcon> */}
        </LinkGroup>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
